/**
 * Shipping cutoff (store IANA timezone).
 * - [data-shipping-cutoff] + [data-shipping-headline]: swap HOY / MAÑANA copy
 * - [data-shipping-visibility="before-cutoff"]: show only before cutoff
 * - PedidosYa home: Mon–Fri before cutoff only (off Fri post-cutoff → Mon)
 * - PedidosYa product: off Fri post-cutoff → Sat; on Sunday with MAÑANA
 * - PedidosYa: grow font to fill one line without wrapping
 * Timezone from #ShippingCutoffConfig[data-timezone]
 */
(function () {
  var DEFAULT_TIMEZONE = 'America/Montevideo';
  var FIT_MAX_REM = 1.35;
  var FIT_MIN_REM = 0.95;
  var fitRaf = null;

  function getTimezone() {
    var config = document.getElementById('ShippingCutoffConfig');
    var tz = config && config.getAttribute('data-timezone');
    return tz && tz.trim() ? tz.trim() : DEFAULT_TIMEZONE;
  }

  function getStoreParts(timeZone) {
    var hour = 0;
    var minute = 0;
    var weekdayShort = 'Mon';

    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      }).formatToParts(new Date());

      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'hour') hour = Number(parts[i].value);
        if (parts[i].type === 'minute') minute = Number(parts[i].value);
        if (parts[i].type === 'weekday') weekdayShort = parts[i].value;
      }
      if (hour === 24) hour = 0;
    } catch (e) {
      var now = new Date();
      hour = now.getHours();
      minute = now.getMinutes();
      weekdayShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][now.getDay()];
    }

    var weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var weekday = weekdayMap[weekdayShort];
    if (typeof weekday !== 'number') weekday = 1;

    return {
      minutes: hour * 60 + minute,
      weekday: weekday,
    };
  }

  function parseCutoffMinutes(cutoff) {
    if (!cutoff) return null;
    var match = String(cutoff).trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return null;
    var h = Number(match[1]);
    var m = Number(match[2]);
    if (h > 23 || m > 59) return null;
    return h * 60 + m;
  }

  function isBeforeCutoff(cutoff, storeMinutes) {
    var cutoffMinutes = parseCutoffMinutes(cutoff);
    if (cutoffMinutes === null) return true;
    return storeMinutes < cutoffMinutes;
  }

  function setElementVisible(element, visible) {
    if (visible) {
      element.classList.add('is-visible');
      element.removeAttribute('hidden');
    } else {
      element.classList.remove('is-visible');
      element.setAttribute('hidden', '');
    }

    var slot = element.closest('.product__pedidosya-slot');
    if (slot) {
      if (visible) slot.removeAttribute('hidden');
      else slot.setAttribute('hidden', '');
    }
  }

  /**
   * Home PedidosYa: visible Mon–Fri before cutoff only.
   * Off from Friday after cutoff through Sunday; back Monday before cutoff.
   */
  function isHomePedidosYaVisible(beforeCutoff, weekday) {
    var isWeekday = weekday >= 1 && weekday <= 5;
    return isWeekday && beforeCutoff;
  }

  /**
   * Product PedidosYa:
   * - Fri after cutoff + Sat → hidden
   * - Sunday → visible with MAÑANA
   * - Mon–Fri before cutoff / Mon–Thu after → visible with HOY/MAÑANA
   */
  function getProductPedidosYaState(beforeCutoff, weekday) {
    if (weekday === 6) {
      return { visible: false, useAfterText: true };
    }
    if (weekday === 5 && !beforeCutoff) {
      return { visible: false, useAfterText: true };
    }
    if (weekday === 0) {
      return { visible: true, useAfterText: true };
    }
    return { visible: true, useAfterText: !beforeCutoff };
  }

  function applyCutoffBanner(element, timeZone) {
    var cutoff = element.getAttribute('data-shipping-cutoff');
    if (!cutoff) return;

    var store = getStoreParts(timeZone);
    var beforeCutoff = isBeforeCutoff(cutoff, store.minutes);
    var visibility = element.getAttribute('data-shipping-visibility');
    var isHomePedidosYa = element.classList.contains('pedidosya-home-banner');
    var isProductPedidosYa = element.classList.contains('product__shipping-banner--pedidosya');

    if (visibility === 'before-cutoff') {
      var homeVisible = isHomePedidosYa
        ? isHomePedidosYaVisible(beforeCutoff, store.weekday)
        : beforeCutoff;
      setElementVisible(element, homeVisible);
      return;
    }

    if (isProductPedidosYa) {
      var state = getProductPedidosYaState(beforeCutoff, store.weekday);
      setElementVisible(element, state.visible);

      var productHeadline = element.querySelector('[data-shipping-headline]');
      if (productHeadline && state.visible) {
        var productBefore = element.getAttribute('data-shipping-before') || '';
        var productAfter = element.getAttribute('data-shipping-after') || '';
        productHeadline.innerHTML = state.useAfterText ? productAfter : productBefore;
      }
      return;
    }

    var headline = element.querySelector('[data-shipping-headline]');
    if (!headline) return;

    var before = element.getAttribute('data-shipping-before') || '';
    var after = element.getAttribute('data-shipping-after') || '';
    headline.innerHTML = beforeCutoff ? before : after;
  }

  function rootFontPx() {
    return parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
  }

  function fitsOneLine(textEl) {
    return textEl.scrollWidth <= textEl.clientWidth + 1;
  }

  function fitPedidosYaText(textEl) {
    if (!textEl) return;

    var root = rootFontPx();
    var maxPx = FIT_MAX_REM * root;
    var minPx = FIT_MIN_REM * root;

    textEl.classList.add('is-fit');
    textEl.style.fontSize = maxPx + 'px';

    if (fitsOneLine(textEl)) return;

    var lo = minPx;
    var hi = maxPx;
    var best = minPx;

    for (var i = 0; i < 14; i++) {
      var mid = (lo + hi) / 2;
      textEl.style.fontSize = mid + 'px';
      if (fitsOneLine(textEl)) {
        best = mid;
        lo = mid;
      } else {
        hi = mid;
      }
    }

    textEl.style.fontSize = best + 'px';

    // iPad ~768 (narrow product column): if it still overflows, wrap to 2 lines.
    if (!fitsOneLine(textEl)) {
      textEl.classList.remove('is-fit');
      textEl.style.fontSize = '';
    }
  }

  function fitAllPedidosYa() {
    var texts = document.querySelectorAll(
      '.product__shipping-banner--pedidosya:not([hidden]) .product__shipping-banner-text'
    );
    for (var i = 0; i < texts.length; i++) {
      fitPedidosYaText(texts[i]);
    }
  }

  function scheduleFit() {
    if (fitRaf) cancelAnimationFrame(fitRaf);
    fitRaf = requestAnimationFrame(function () {
      fitRaf = null;
      fitAllPedidosYa();
    });
  }

  function initFitObservers() {
    var slots = document.querySelectorAll(
      '.product__pedidosya-slot, .product__shipping-banner--pedidosya'
    );
    if (!slots.length || typeof ResizeObserver === 'undefined') return;

    var observer = new ResizeObserver(scheduleFit);
    for (var i = 0; i < slots.length; i++) {
      observer.observe(slots[i]);
    }
  }

  function init() {
    var timeZone = getTimezone();
    var banners = document.querySelectorAll('[data-shipping-cutoff]');
    for (var i = 0; i < banners.length; i++) {
      applyCutoffBanner(banners[i], timeZone);
    }
    fitAllPedidosYa();
    initFitObservers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
